import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useFeatureAddon } from "@/features/plan/hooks";
import type { FeatureAddonKey } from "@/features/plan/types";

/**
 * Gates a route on an opt-in addon (OPPOSITE of FeatureGateRoute semantics:
 * absent = disabled, redirects to /dashboard). Loading shows a spinner so the
 * route doesn't bounce the user before plan-limits has resolved.
 *
 * No FEATURE_ADDONS entries as of the MLM module dissolution (#5338) — kept
 * as shared substrate for the next opt-in module to mount the same guard.
 */
export function FeatureAddonRoute({
  addon,
  children,
  redirectTo = "/dashboard",
}: {
  addon: FeatureAddonKey;
  children: ReactNode;
  redirectTo?: string;
}) {
  const { enabled, loading } = useFeatureAddon(addon);

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-slate-50">
        <p className="text-sm text-slate-500">Loading…</p>
      </div>
    );
  }

  if (!enabled) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
}
